export const customerProductTypes = {
  hoy: 'Hoy',
  schoolwiki: 'Schoolwiki',
  brugger: 'Brugger',
}

export default (type) => customerProductTypes[type] || type
